import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "84",
  height: "85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M37.833 21.667h8.333V30h-8.333v-8.333Zm0 16.666h8.333v25h-8.333v-25ZM42 .834C19 .833.333 19.5.333 42.5S19 84.167 42 84.167 83.666 65.5 83.666 42.5 65 .833 42 .833Zm0 75c-18.375 0-33.334-14.958-33.334-33.333S23.625 9.167 42 9.167c18.375 0 33.333 14.958 33.333 33.333S60.375 75.834 42 75.834Z",
  fill: "#E1F5FE"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };